/**
 * Meta Pixel (Facebook Pixel) — instalación con seguimiento de PageView.
 *
 * 👉 REEMPLAZÁ el valor de META_PIXEL_ID por tu Pixel ID real de Meta
 *    (lo encontrás en Events Manager → Orígenes de datos → tu pixel).
 */
export const META_PIXEL_ID = '2216661565735770'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
    }
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Inyecta el snippet base de Meta Pixel, inicializa el pixel y dispara un PageView.
 * Es idempotente: si ya se inicializó, no vuelve a inyectar nada.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || initialized) return
  if (!pixelId || pixelId === 'pixel id') {
    // Placeholder sin reemplazar: evitamos inicializar con un ID inválido.
    // Reemplazá META_PIXEL_ID por tu ID real para activar el seguimiento.
    return
  }

  /* eslint-disable */
  // Snippet base oficial de Meta Pixel
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')

  initialized = true
}

/** Dispara manualmente un PageView (útil si agregás navegación por rutas). */
export function trackPageView(): void {
  if (typeof window !== 'undefined') {
    window.fbq?.('track', 'PageView')
  }
}
